module.exports = __webpack_public_path__ + "static/media/magento3.40810b72.PNG";